import { type Locale } from 'date-fns/locale';
import { DateLib, type Formatters } from 'react-day-picker';

export const createCalendarFormatters = (locale: Locale): Partial<Formatters> => {
  const defaultLib = new DateLib({ locale });

  return {
    formatMonthDropdown: date => defaultLib.format(date, 'MMM'),
    formatCaption: (month, _options, dateLib): string => {
      const lib = dateLib ?? defaultLib;
      const caption = lib.formatMonthYear(month);
      return caption.charAt(0).toUpperCase() + caption.slice(1);
    },
    formatWeekdayName: (weekday, _options, dateLib): string => {
      const lib = dateLib ?? defaultLib;
      return lib.format(weekday, 'ccc');
    },
  };
};
